<ng-template #userDetails let-user="user">
  @if (user) {
    <span>{{ user.email }}</span>
  }
  @if (!user) {
    <span i18n="@@diu-nouser">No booking for user</span>
  }
</ng-template>

<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@diu-header" id="modal-header">
      Warning - Different Booking For Users
    </h3>
    <button
      type="button"
      class="close"
      aria-label="Cancel"
      ngbAutoFocus
      (click)="activeModal.close(DifferentInvokdedUserReasons.cancel)"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <span i18n="@@diu-body1">The current booking for user ( </span>
      <ng-container
        [ngTemplateOutlet]="userDetails"
        [ngTemplateOutletContext]="{ user: currentBobo }"
      ></ng-container>
      <span i18n="@@diu-body2"> ) and the one assigned to the </span>
      <span>{{ displayItinerary ? ('itinerary' | translate) : ('basket' | translate) }} (</span>
      <ng-container
        [ngTemplateOutlet]="userDetails"
        [ngTemplateOutletContext]="{ user: basketBobo }"
      ></ng-container>
      <span i18n="@@diu-body3">) are different.</span>
    </div>
    <div>
      <span i18n="@@diu-body4">
        These need to be the same. Please choose one of the options below
      </span>
      <ul>
        <li>
          <span i18n="@@diu-body-newbasket-create">Create a new </span>
          <span>{{ displayItinerary ? ('itinerary' | translate) : ('basket' | translate) }}</span>
          <span i18n="@@diu-body-newbasket-user"> with this booking for user.</span>
        </li>
        <li i18n="@@diu-body-research">
          Change the current booking for user and perform the search again.
        </li>
        <li>
          <span i18n="@@diu-body-cancel-lead">Cancel adding the item to the </span>
          <span>{{ displayItinerary ? ('itinerary' | translate) : ('basket' | translate) }}.</span>
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="modal_button_okay"
      (click)="activeModal.close(DifferentInvokdedUserReasons.newBasket)"
    >
      <span i18n="@@diu-newBasket-create">Create new </span>
      <span>{{ displayItinerary ? ('itinerary' | translate) : ('basket' | translate) }}</span>
    </button>
    <button
      type="button"
      class="modal_button_okay"
      (click)="activeModal.close(DifferentInvokdedUserReasons.research)"
      [disabled]="isAgent"
      i18n="@@diu-research"
    >
      Search Again
    </button>
    <button
      type="button"
      class="modal_button_okay"
      (click)="activeModal.close(DifferentInvokdedUserReasons.cancel)"
      i18n="@@diu-cancel"
    >
      Cancel
    </button>
  </div>
</div>
